import { render } from "./OverrideConfirm.vue?vue&type=template&id=be5c14a4&ts=true"
import script from "./OverrideConfirm.vue?vue&type=script&lang=ts"
export * from "./OverrideConfirm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__